import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { entiyFeatureType, condtionType } from 'types';
import { FormGroupSelect } from 'components/Form';
import TagsAutocompleteInput from 'components/TagsAutocompleteInput';
import TrashTooltip from 'components/TrashTooltip';
import { getAvailableFeatureOptions, getFilteredSuggestions } from './utils';

import './style.scss';

class FeatureField extends Component {
  static propTypes = {
    condition: condtionType,
    feature: PropTypes.string,
    item: entiyFeatureType,
    onChangeFeatureValues: PropTypes.func,
    onDelete: PropTypes.func,
  };

  getSuggestions = inputValue => {
    const {
      item,
      // eslint-disable-next-line camelcase
      condition: { entity_reference_obj },
    } = this.props;

    return getFilteredSuggestions(
      item.feature,
      entity_reference_obj.featuresMap,
      inputValue,
    );
  };

  handleChangeFeatureValues = equalsValues =>
    this.props.onChangeFeatureValues(equalsValues, this.props.item);

  handleDelete = () => {
    this.props.onDelete(this.props.item);
  };

  handleOnChangeFeature = () => {
    this.props.onChangeFeatureValues([], this.props.item);
  };

  // TODO: get the form entity_reference_obj.featuresMap[id].available_values
  validationRegex = {
    Actor: /customer|company|system|other|undefined/,
    Aspect: /perfective|imperfective/,
    GrammarNumber: /singular|plural/,
    Boolean: /true|false/,
    Integer: /^[0-9]+$/,
    Mood: /volition|negation|undefined/,
    PartOfSpeech: /noun|pronoun|verb|adjective|adverb|preposition|conjunction|article/,
    String: /.*/,
    Possessor: /customer|company|system|other|undefined/,
    Tense: /past|present|future|undefined/,
  };

  render() {
    const {
      item,
      feature,
      // eslint-disable-next-line camelcase
      condition: { entity_reference_obj, features },
    } = this.props;

    if (!entity_reference_obj.featuresMap[item.feature]) {
      return null;
    }

    return (
      <div styleName="feature">
        <div styleName="inner">
          <Field
            component={FormGroupSelect}
            disabled={entity_reference_obj.archived}
            isArchived={entity_reference_obj.featuresMap[item.feature].archived}
            name={feature}
            options={getAvailableFeatureOptions(
              entity_reference_obj.featuresMap,
              features,
              item.feature,
            )}
            onChange={this.handleOnChangeFeature}
          />
          <div styleName="operator">Equals</div>

          <div data-test="tag-input">
            <TagsAutocompleteInput
              getSuggestions={this.getSuggestions}
              inputProps={{ placeholder: 'Enter text' }}
              isDisabled={entity_reference_obj.archived}
              item={item}
              validationRegex={
                this.validationRegex[
                  entity_reference_obj.featuresMap[item.feature].feature_type
                ]
              }
              value={item.equals_values}
              onChangeValues={this.handleChangeFeatureValues}
            />
          </div>
        </div>

        <TrashTooltip text="Delete feature" onDelete={this.handleDelete} />
      </div>
    );
  }
}

export default FeatureField;
